import type { GamePhase } from '@bm/shared';
import { de } from '@/i18n/de';

export function PhaseChip({ phase, round }: { phase: GamePhase; round: number }) {
  return (
    <div className="flex items-center gap-2 text-sm text-fg-muted">
      <span className="rounded-full bg-surface-2 px-2.5 py-1 font-medium text-fg">
        {de.phases[phase]}
      </span>
      {round > 0 && phase !== 'LOBBY' && <span>{de.history.round(round)}</span>}
    </div>
  );
}
